<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="component-header-title">
      <h2>Edit Director</h2>
      @if (directorFullName) {
        <p class="component-header-subtitle">
          @if (directorCode) {
            <span class="director-code">{{ directorCode }}</span>
          }
          {{ directorFullName }}
        </p>
      }
    </div>
    @if (fromCompanyId) {
      <a [routerLink]="['/companies/edit', fromCompanyId]" [queryParams]="{ tab: 'board', year: fromYear }" class="back-to-company-link">
        <mat-icon>open_in_new</mat-icon>
        {{ fromCompanyName || 'Company' }} — Board
      </a>
    }
  </div>
  <app-director-form
    [form]="form"
    [isEditMode]="true"
    [positions]="positions"
    submitButtonText="Update Director"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-director-form>
</div>
